const binding = { modules: {}, dataActions: {} };

    (binding.modules['dyn-content-block-secured-links'] = {
        c: () => require('partner/modules/dyn-content-block-secured-links/dyn-content-block-secured-links.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'dyn-content-block-secured-links',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/dyn-content-block-secured-links'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|dyn-content-block-secured-links|dyn-content-block-secured-links'] = {
                c: () => require('partner/modules/dyn-content-block-secured-links/dyn-content-block-secured-links.view.tsx'),
                cn: '__local__-__local__-dyn-content-block-secured-links'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };